import React, { useEffect, useState } from 'react';
import NftPreview from '../../components/nft/NftPreview';
import { CardsLoader } from '../../components/Skeleton/CardsLoader';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useMint } from '../events/event/mint/MintNftProvider';
import { CLUBBED_LEVELS } from './Levels';
import './NftContainer.scss';
import img from '../arrow.svg';

const NftContainer = ({ event, nftProfile, campaign, step1, step2, step3, step4Ref }) => {
  const [{ user }] = useGlobalState();
  const [{ steps, step }] = useMint();
  const [isOpen, setIsOpen] = useState(true);

  function liesBetween(level) {
    if (!level) return null;
    const currentLevel = Number(nftProfile?.properties?.Level?.details?.level);
    if (level?.openLevel <= currentLevel && level?.closeLevel >= currentLevel) return true;
    return false;
  }

  // function animateBorderBasedOnEdges(level) {
  //   const nftBorder = document.querySelector('.nft_preview_border');

  //   nftBorder.style.animation = 'none';
  //   void nftBorder.offsetWidth; // Re-trigger animation

  //   // Determine active edges based on level
  //   let edgePercentage = 0;
  //   if (level % 5 === 1) edgePercentage = 25; // Up to first edge
  //   if (level % 5 === 2) edgePercentage = 50; // Up to second edge
  //   if (level % 5 === 3) edgePercentage = 75; // Up to third edge
  //   if (level % 5 === 0 && level > 0) edgePercentage = 100; // Full border

  //   nftBorder.style.background = `
  //     linear-gradient(
  //       270deg,
  //       white ${edgePercentage}%,
  //       rgba(255, 255, 255, 0) ${edgePercentage}%
  //     ) border-box
  //   `;
  //   nftBorder.style.transition = 'background 2s ease-in-out';
  // }

  function updateLighting(level) {
    // Select the edges and reset their state
    const rightEdge = document.querySelector('.right_edge');
    const leftEdge = document.querySelector('.left_edge');
    const bottomLeftEdge = document.querySelector('.bottom_left_edge');
    const bottomRightEdge = document.querySelector('.bottom_right_edge');
    const globe = document.querySelector('.globe');

    const elements = [rightEdge, leftEdge, bottomLeftEdge, bottomRightEdge, globe];
    elements.forEach(el => el.classList.remove('nft_edge_light'));

    const sequence = [];
    if (level % 5 === 1) {
      sequence.push(rightEdge);
    } else if (level % 5 === 2) {
      sequence.push(rightEdge, bottomRightEdge);
    } else if (level % 5 === 3) {
      sequence.push(rightEdge, bottomRightEdge, bottomLeftEdge);
    } else if (level % 5 === 4) {
      sequence.push(rightEdge, bottomRightEdge, bottomLeftEdge, leftEdge);
    } else if (level % 5 === 0 && level > 0) {
      sequence.push(rightEdge, bottomRightEdge, bottomLeftEdge, leftEdge, globe);
    }

    sequence.forEach((element, index) => {
      setTimeout(() => {
        element.classList.add('nft_edge_light');
      }, index * 500);
    });
  }

  useEffect(() => {
    const currentLevel = Number(nftProfile?.properties?.Level?.details?.level || 0);
    if (!currentLevel) return;
    updateLighting(currentLevel);
    // animateBorderBasedOnEdges(currentLevel)
  }, [nftProfile]);

  if (!steps?.length) return <CardsLoader rows={1} columns={1} columnHeight={200} />;
  return (
    <div className='nft-container'>
      <div className='nft-stats'>
        {user && nftProfile ? (
          <>
            <div className='level' ref={step1}>
              <div className='white_line'></div>
              <p>Reputation Level</p>
              <div className='white_line'></div>
            </div>
            {/* <div className='level_name'>{nftProfile?.properties?.Level?.details?.name}</div> */}
            <div className='level_name'>
              {(() => {
                const name = nftProfile?.properties?.Level?.details?.name || '';
                const words = name?.split(' ');

                return (
                  <>
                    {words?.[0] || ''}
                    {words?.[1] && (
                      <>
                        <span>{words[1]}</span>
                      </>
                    )}
                    {words?.length > 2 && ' ' + words?.slice(2)?.join(' ')}
                  </>
                );
              })()}
            </div>
          </>
        ) : (
          <>
          <div className='level' ref={step1}>
              <div className='white_line'></div>
              <p>Reputation Level</p>
              <div className='white_line'></div>

            </div>
            <div className='login_to_discover'>
            Login To Reveal
            </div>
          </>
        )}
      </div>
      <div class='nft_preview_border'>
        <div class='right_edge' ref={step3}></div>
        <div class='left_edge'></div>
        <div class='bottom_left_edge'></div>
        <div class='bottom_right_edge'></div>
        <div class='nft-preview'>
          {user && nftProfile ? (<div class='globe' ref={step2}>
            {nftProfile?.properties?.Level?.details?.level || 0}
          </div>) :(<div class='globe' ref={step2}>
            { 0}
          </div>)}
          
          <div class='border_active'></div>
          <NftPreview className='xion_preview' src={nftProfile?.animation_url} template={campaign?.template} />
        </div>
      </div>

      {user && nftProfile ? (
        <div className='nft-stats'>
          {/* <h2>{nftProfile?.name}</h2> */}
          <div className='collection'>
            <div className='collection_header'>
              
              <button className='dropdown_button' onClick={() => setIsOpen(!isOpen)}>
                <h6>{isOpen ? 'Hide Reputation Positions' : 'View Reputation Positions'}</h6>
                <img src={img} alt='Dropdown Arrow' className={isOpen ? 'arrow rotated' : 'arrow'} />
              </button>
            </div>
            {isOpen && (
              <div className={`collection_container`}>
                {CLUBBED_LEVELS.map(item => (
                  <div className={`collection_card ${liesBetween(item) ? 'card_highlight' : ''}`}>
                    {liesBetween(item) && (
                      <div className='tag' ref={step4Ref}>
                        YOU`RE HERE <br />↓
                      </div>
                    )}
                    <img src={item?.img} alt = "" />
                    <h5>{item?.name}</h5>
                    <p>
                      Level- {item?.openLevel}-{item?.closeLevel}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* <div className='footer'>
            <p>
              <a target='_blank' href='https://backend.mercle.xyz/misc/mercleDiscordInvite'>
                Need Help? Join Our Discord & Create a Ticket!{' '}
              </a>
            </p>
            <p></p>
          </div> */}
        </div>
      ) : (
        <div className='nft-stats'>
          {/* <h2>{nftProfile?.name}</h2> */}
          <div className='collection'>
            <div className='collection_header'>
              
              <button className='dropdown_button' onClick={() => setIsOpen(!isOpen)}>
                <h6>{isOpen ? 'Hide Reputation Positions' : 'View Reputation Positions'}</h6>
                <img src={img} alt='Dropdown Arrow' className={isOpen ? 'arrow rotated' : 'arrow'} />
              </button>
            </div>
            {isOpen && (
              <div className={`collection_container`}>
                {CLUBBED_LEVELS.map(item => (
                  <div className={`collection_card`}>
                    <img src={item?.img} alt = "" />
                    <h5>{item?.name}</h5>
                    <p>
                      Level- {item?.openLevel}-{item?.closeLevel}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        // <div className='nft-stats'>
        //   {/* <div className='level'> */}
        //   <h1 className='lg-screen'>{event?.overview?.title || 'Mint Your NFT To Continue'}</h1>
        //   <div className='level lg-screen'>
        //     <p className='text_break'>
        //       {' '}
        //       {event?.overview?.text ||
        //         'Helu ser! Welcome to the campaign. You need to first mint this mNFT to verify the actions below. mNFTs are data storage vaults that keep storing all the claims of your completed actions.'}
        //     </p>
        //   </div>
        //   {/* <div className='collection'>
        //     <h6>Reputation positions</h6>
        //     <div className={`collection_container`}>
        //       {event?.levelConfig?.levels.length == 0 && <div className='empty_collection'>Your collection is waiting to be filled.</div>}
        //       {CLUBBED_LEVELS.map(item => (
        //         <div className={`collection_card`}>
        //           <img src={item?.img} />
        //           <h5>{item?.name}</h5>
        //           <p>
        //             Level- {item?.openLevel}-{item?.closeLevel}
        //           </p>
        //         </div>
        //       ))}
        //     </div>
        //   </div> */}
        //   <div className='mint-steps'>{steps[step]}</div>
        // </div>
        
      )}
      <div className='full_white_line'>
      </div>
    </div>
  );
};

export default NftContainer;
